/**
 * Implements a page navigation bar
 */
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import ConnectedWallet from '../../components/ConnectedWallet';
import ChartPicker from '../../components/Picker';
import Research from '../../components/Research';
import Trending from '../../components/Trending';
import News from '../../components/News';
import NetworkSelector from '../../components/NetworkSelector';
import { IStore } from '../../reducers';
import { actionOpenTickers } from '../../actions/modal';
import logo from '../../assets/images/kattana_logo.svg';

import './styles.scss';

interface IHeaderProps {
  chartPicker?: boolean;
}

const Header = ({ chartPicker = true }: IHeaderProps) => {
  const {
    id,
    base,
    quote,
    flipped
  } = useSelector((state: IStore) => state.current);
  const logoRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();

  /**
   * Call logo shimmer animation
   */
  useEffect(() => {
    let timer: number;

    window.requestAnimationFrame(() => {
      if (logoRef.current) {
        logoRef.current.classList.add('logo--updating');
      }

      timer = window.setTimeout(() => {
        if (logoRef.current) {
          logoRef.current.classList.remove('logo--updating');
        }
      }, 1500);
    });

    return () => window.clearTimeout(timer);
  }, [id]);

  /**
   * Change page title in trading
   */
  useEffect(() => {
    if (document && base && quote) {
      const title = flipped ? `${quote}/${base} ✓ Trade ${quote} to ${base} | Buy ${quote} (coin)| livechart on Kattana`
        :`${base}/${quote} ✓ Trade ${base} to ${quote} | Buy ${base} (coin)| livechart on Kattana`;
      document.title = title;
    }
  }, [
    base,
    quote,
    flipped
  ]);

  return (
    <div className='global_header'>
      <div className='global_header__block'>
        <Link to='/ETH/0x92dBB765f587F6E16C07C799E0dB6A1f3AF498B8'>
          <div className='logo' ref={logoRef}>
            <Image size='m' src={logo} />
          </div>
        </Link>
      </div>
      <div className='global_header__block'>
        {chartPicker && <ChartPicker />}
      </div>
      <div className='global_header__block global_header__block--filler'>
        <div
          className='find'
          onClick={() => dispatch(actionOpenTickers({ center: false }))}
        >
          <Text className='find__text' size={14}>
            Search Market, Ticker or Token Address...
          </Text>
        </div>
      </div>
      <div className='global_header__block'>
        <Research />
      </div>
      <div className='global_header__block'>
        <Trending />
      </div>
      <div className='global_header__block'>
        <NetworkSelector />
      </div>
      <div className='global_header__block'>
        <ConnectedWallet />
      </div>
      <div className='global_header__block'>
        <News />
      </div>
      {/* <div className="global_header__block">
        <GasPrice />
      </div> */}

      {/* <div className="find" onClick={() => actionOpenTickers({ center: false })}><div className="find__text">Find</div></div> */}

      {/* <Link to={`${window.location.origin}/uniswap/0x92dBB765f587F6E16C07C799E0dB6A1f3AF498B8`} className={`trade last_item ${isResearch ? '' : 'trade--active'}`}><div className="trade__text">Trade</div></Link> */}
      {/* <div className="proTrade disabled_feature"><div className="proTrade__text">Pro Trade</div></div> */}
    </div>
  );
};

export default Header;
